<template>
  <div>
    <b-navbar toggleable="lg" type="dark" variant="info">
      <b-navbar-brand>
        <img :src="obrazek" width="60px" class="d-inline-block align-top" alt="logo" />
      </b-navbar-brand>
      <b-navbar-brand>
        <h4 style="margin:0px!important">{{nazev}}</h4>
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-form-input
            size="sm"
            class="mr-sm-2"
            v-model="searchbar"
            @input="searchbarData"
            placeholder="Vyhledávání"
          ></b-form-input>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-dropdown
            style="margin: auto;"
            text="Seznam surovin"
            class="m-2"
            block
            variant="success"
            menu-class="w-100"
          >
            <b-dropdown-text
              style="margin:5px;"
              v-if="seznam.length === 0"
            >Nejdřív přidej suroviny a potom jdi sem.</b-dropdown-text>
            <b-dropdown-text
              style="margin:5px;"
              v-for="surovina in this.$store.state.seznam"
              :key="surovina"
            >
              {{surovina}}
              <b-button variant="danger" @click="removeFromSeznam(surovina)">-</b-button>
              <b-dropdown-divider></b-dropdown-divider>
            </b-dropdown-text>
            <b-dropdown-divider v-if="seznam.length !== 0"></b-dropdown-divider>
            <b-dropdown-divider v-if="seznam.length !== 0"></b-dropdown-divider>
            <b-dropdown-item-button variant="primary" v-if="seznam.length !== 0" @click="copy">Do schránky</b-dropdown-item-button>
            <b-dropdown-item-button
              variant="danger"
              v-if="seznam.length !== 0"
              @click="removeSeznam"
            >Smazat</b-dropdown-item-button>
          </b-dropdown>

          <multiselect
            v-model="value"
            :options="stitky"
            :multiple="true"
            @input="stitkyBarData"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Vyber štítek"
            label="name"
            track-by="name"
            :preselect-first="true"
          ></multiselect>
          <b-nav-item href="https://kucharka.zvara.cz/login.php">Přihlášení</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "Card",
  components: { Multiselect },
  props: {
    nazev: String,
    obrazek: String,
    stitky: Array
  },
  data() {
    return {
      seznam: this.$store.state.seznam,
      value: [],
      searchbar: ""
    };
  },
  methods: {
    searchbarData() {
      this.$emit("searchBarData", this.searchbar);
    },
    stitkyBarData() {
      this.$emit("stitkyBarData", this.value);
    },
    removeFromSeznam(surovina) {
      this.$store.commit("removeFromSeznam", surovina);
    },
    removeSeznam() {
      this.$store.commit("removeSeznam");
      this.$store.state.seznam = [];
      this.seznam = this.$store.state.seznam;
    },
    copy () {
          this.$copyText(this.$store.state.seznam.toString()).then(function () {
          alert('Copied')
        }, function (e) {
          alert('Can not copy' + e)
        })
    }
  }
};
</script>
  <style scoped>
.navbar-dark {
  background-color: #18720cf6 !important;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>